export const getVideoVariant = (videoWidth, theme) => {
  let headerProps = {};
  let titleProps = {};
  let buttonProps = {};
  if (videoWidth < theme?._breakpoints[0]) {
    headerProps = {
      fontSize: 0,
      mb: 2,
    };
    titleProps = {
      fontSize: 2,
      mb: 3,
    };
    buttonProps = {
      sysButtonProps: {
        px: 4,
        py: 1,
      },
      messageProps: {
        fontSize: 1,
      },
    };
  } else {
    headerProps = {
      fontSize: 2,
      mb: 2,
    };
    titleProps = {
      fontSize: 4,
      mb: 6,
    };
    buttonProps = {
      sysButtonProps: {
        px: 5,
        py: 2,
      },
      messageProps: {
        fontSize: 2,
      },
    };
  }
  return { headerProps, titleProps, buttonProps };
};

export const getAutoNextVideoVariant = (videoWidth, theme) => {
  let headerProps = {};
  let titleProps = {};
  let buttonProps = {};
  if (videoWidth < theme?._breakpoints[0]) {
    headerProps = {
      fontSize: 0,
      mb: 2,
    };
    titleProps = {
      fontSize: 4,
      mb: 2,
      px: 7,
    };
    buttonProps = {
      wrapperProps: {
        mt: 5,
      },
      sysButtonProps: {
        px: 4,
        py: 1,
        minWidth: '120px',
        borderWidth: '1px',
      },
      messageProps: {
        fontSize: 1,
      },
      iconProps: {
        mr: 2,
        size: 20,
      },
    };
  } else {
    headerProps = {
      fontSize: 2,
      mb: 2,
    };
    titleProps = {
      fontSize: 5,
      mb: 4,
      px: '80px',
    };
    buttonProps = {
      wrapperProps: {
        mt: 6,
      },
      sysButtonProps: {
        px: 6,
        py: 2,
        minWidth: '145px',
        borderWidth: '2px',
      },
      messageProps: {
        fontSize: 2,
      },
      iconProps: {
        mr: 2,
        size: 20,
      },
    };
  }
  return { headerProps, titleProps, buttonProps };
};
